<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div style="min-height:30vh">
        <table>
          <thead>
            <tr>
              <th class="ts-text-xs">
                {{ $t('studentScoringEntry.componentSub') }}
              </th>
              <th class="ts-text-xs text-center">
                {{ $t('studentScoringEntry.actualScore') }}
              </th>
              <th class="ts-text-xs text-right">
                {{ $t('studentScoringEntry.maxScore') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(mainData, index) in dataInput">
              <tr :key="index">
                <td class="ts-text-sm text-left">
                  <span class="badge badge-primary">
                    <p>{{ getComponentName(mainData.sc_subject_id).kh }}</p>
                    <p>{{ getComponentName(mainData.sc_subject_id).en }}</p>
                  </span>
                </td>
                <td colspan="2" class="ts-text-xs text-right">
                  <span class="badge badge-info">{{
                    getActualScoreMainComponent(mainData.sc_subject_id)
                  }}</span>
                </td>
              </tr>
              <tr v-for="(sub, index) in mainData.sc_item_subject_comp_list">
                <td class="text-right ts-text-xs">
                  {{
                    getSubcomponentName(
                      mainData.sc_subject_id,
                      sub.sc_item_subject_comp_id
                    )
                  }}
                </td>
                <td>
                  <div
                    v-if="
                      isAutoFromAttendance(
                        mainData.sc_subject_id,
                        sub.sc_item_subject_comp_id
                      )
                    "
                  >
                    <!-- v-if="sub.actual_score <= 0" -->
                    <span style="display: none">{{
                      getScoreAutoFromAttendance(mainData.sc_subject_id,sub)
                    }}</span>
                  </div>
                  <input
                    type="number"
                    v-model.number="sub.actual_score"
                    class="text-right ts-w-40 form-control form-control-sm"
                    :disabled="
                      isAutoFromAttendance(
                        mainData.sc_subject_id,
                        sub.sc_item_subject_comp_id
                      )
                    "
                    :max="sub.max_score"
                    :class="{
                      'is-invalid': errors.has(
                        'sc_item_subject_comp_list.' +
                          sub.sc_item_subject_comp_id +
                          '.actual_score'
                      )
                    }"
                  />
                </td>
                <td
                  class="ts-whitespace-no-wrap ts-w-24"
                  @dblclick="() => (sub.disable = false)"
                >
                  <input
                    type="number"
                    v-model.number="sub.max_score"
                    class="text-right inline-block form-control form-control-sm"
                    :disabled="sub.disable"
                  />
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="row mt-3">
        <div class="col-md-8 d-flex align-items-center">
          <p class="text-danger" v-if="show_alert">
            <i class="fas fa-exclamation-triangle"></i>
            <span class="ts-text-xs">{{
              $t(
                'studentscoringentry.somethingwrongwithabovecomponentPleasecheckitandtrytoclickbuttonsaveagain'
              )
            }}</span>
          </p>
        </div>
        <div class="col-md-4 text-right">
          <ts-button class="mr-2" @click.prevent="$emit('closeModal')">{{
            $t('cancel')
          }}</ts-button>
          <ts-button
            color="primary"
            @click.prevent="onSave"
            :waiting="waiting"
            >{{ $t('save') }}</ts-button
          >
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'studentScoringEntryNumeric',
  props: ['value'],
  data () {
    return {
      waiting: false,
      loading: false,
      show_alert: false,
      advisor_comment: false,
      errors: new Errors(),
      scoreComponents: [],
      model: {},
      dataInput: [],
      successCreate: [],
      actual_score_for_main_component_display: [] // for display max score on main component
    }
  },
  created() {
    this.model = this.value
    this.fetchData()
  },
  computed: {},
  methods: {
    ...mapActions('studentScoringEntry', [
      'getProgramStructure',
      'getComponent',
      'findScoreAssementDetail',
      'store',
      'findScoring',
      'getScoreFromAttendance'
    ]),
    onAdvisorComment() {
      this.advisor_comment = true
    },
    findScoringInput() {
      let { sc_item_subject_comp_list, sc_subject_id, st_class_id, ...params } =
        this.model
      return this.findScoring(params)
    },
    async fetchData() {
      this.loading = true
      let structure = await this.getProgramStructure({ ...this.model }).catch(
        (error) => {
          this.$toasted.error(error.message)
        }
      )
      await this.getComponent({
        // get component base on what score assement main setup
        ...structure.data
      })
        .then(response => {
          this.scoreComponents = response.data
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
      await this.findScoreAssementDetail({
        ...structure.data,
        subject_id: this.model.sc_subject_id
      }) // find score assement detail by score asessment id and program structure id
        .then(response => {
          this.createInputData(response.data)
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
      await this.findScoringInput()
        .then((response) => {
          if (!_.isEmpty(response.data) || response.data.length > 0) {
            this.dataInput.forEach((el) => {
              if (response.data[el.sc_subject_id] !== undefined) {
                response.data[el.sc_subject_id].forEach((edit) => {
                  el.sc_item_subject_comp_list
                    .filter(
                      (item) =>
                        item.sc_item_subject_comp_id ==
                        edit.sc_item_subject_comp_id
                    )
                    .forEach((subItem) => {
                      subItem.actual_score = edit.actual_score
                      subItem.disable = edit.disable
                      subItem.max_score = edit.max_score
                      subItem.sc_item_subject_comp_id =
                        edit.sc_item_subject_comp_id
                      subItem.sc_subject_id = edit.sc_subject_id
                      subItem.scoring_id = edit.scoring_id
                    })
                    //set edit data unit title
                    this.unit_title = edit.unit_title
                })
              }
            })
          }
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    createInputData (data) {
      data.forEach(el => {
        this.actual_score_for_main_component_display.push({
          sc_subject_id: el.sc_subject_id,
          actual_score:
            el.enable_semester == true && this.model.scoring_cycle_id == 2
              ? el.enable_sciense == true
                ? el.actual_score_sciense_semester
                : el.actual_score_semester
              : el.actual_score
        })
        this.dataInput.push(
          Object.assign({}, this.model, {
            sc_subject_id: el.sc_subject_id,
            sc_item_subject_comp_list: this.createSub(el).sort((a, b) => {
              return a.display_order - b.display_order
            })
          })
        )
      })
    },
    // create sub display comment score input
    createSub(item) {
      if (this.model.sc_bas_id == 2) {
        // subject base
        return [
          {
            scoring_id: 0,
            sc_item_subject_comp_id: item.sc_subject_id,
            actual_score: -1,
            max_score:
              item.enable_semester == true && this.model.scoring_cycle_id == 2
                ? item.enable_sciense == true
                  ? item.actual_score_sciense_semester
                  : item.actual_score_semester
                : item.actual_score,
            disable: true,
            display_order: 0,
          },
        ]
      }
      if (this.model.sc_bas_id == 1) {
        // item base
        return item.component_detail_item_list.map(el => ({
            scoring_id: 0,
            sc_item_subject_comp_id: el.sc_item_subject_comp_id,
            actual_score: -1,
            max_score:
              el.enable_semester == true && this.model.scoring_cycle_id == 2
                ? el.enable_sciense == true
                  ? el.actual_score_sciense_semester
                  : el.actual_score_semester
                : el.actual_score,
            disable: true,
            display_order: this.getOrderDisplay(
              item.sc_subject_id,
              el.sc_item_subject_comp_id
            )
          }))
      }
    },
    getComponentName(sc_subject_id) {
      return this.scoreComponents
        .filter((c) => c.id == sc_subject_id)
        .reduce(
          (init, item) => (init = { kh: item.name_native, en: item.name }),
          null
        )
    },
    getActualScoreMainComponent(sc_subject_id) {
      return this.actual_score_for_main_component_display
        .filter((a) => a.sc_subject_id == sc_subject_id)
        .reduce((init, item) => (init = item.actual_score), null)
    },
    getSubcomponentName (sc_subject_id, sc_item_subject_comp_id) {
      if (this.model.sc_bas_id  == 2) {
        return this.getComponentName(sc_subject_id).en
      }
      return this.scoreComponents
        .filter((c) => c.id == sc_subject_id)
        .flatMap((el) =>
          el.items.filter((item) => item.id == sc_item_subject_comp_id)
        )
        .reduce((init, item) => (init = item.name), null)
    },
    getOrderDisplay(sc_subject_id, sc_item_subject_comp_id) {
      // if (this.model.scoring_cycle_id == 2) {
      //   return 0
      // }
      return this.scoreComponents
        .filter((c) => c.id == sc_subject_id)
        .flatMap((el) =>
          el.items.filter((item) => item.id == sc_item_subject_comp_id)
        )
        .reduce((init, item) => (init = item.display_order), 0)
    },
    async onSave() {
      this.waiting = true
      this.successCreate = []
      this.show_alert = false
      for (const item of this.dataInput) {
        await this.store(item)
          .then((response) => {
            this.successCreate.push(item)
          })
          .catch((error) => {
            this.show_alert = true
            this.waiting = false
            this.$toasted.error(error.message)
            if (error.errors != undefined) {
              this.errors = new Errors(error.errors)
            }
          })
        if (this.show_alert) {
          break
        }
      }
      this.successCreate.forEach(async (el) => {
        await this.dataInput.splice(this.dataInput.indexOf(el), 1)
      })
      this.waiting = false
      if (this.dataInput.length == 0) {
        this.$emit('closeModal')
      }
    },
    isAutoFromAttendance(sc_subject_id, sc_item_subject_comp_id) {
      return this.scoreComponents
        .filter(c => c.id == sc_subject_id)
        .flatMap(el =>
          el.items.filter(item => item.id == sc_item_subject_comp_id)
        )
        .reduce((init, item) => (init = item.is_auto_from_att), false)
    },
    async getScoreAutoFromAttendance(sc_subject_id, sub) {
      let result = await this.getScoreFromAttendance({
        params: {
          student_id: this.model.student_id,
          class_id: this.model.class_id,
          subject_id: sc_subject_id
        }
      })
      sub.actual_score = result.actual_score > 0 ? result.actual_score : 0
    }
  }
}
</script>

<style lang="css" scoped>
table {
  width: 100%;
}
table > thead {
  border-bottom: 1px solid #d8d8d8;
  padding: 3px;
}
table > thead > tr > th {
  padding: 4px 7px;
}
table > tbody > tr > td {
  padding: 4px 7px;
}
.bb {
  border-bottom: 1px solid #d8d8d8;
  outline: none;
}
.cover {
  opacity: 0.2;
}
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.list-group-item {
  border: none !important;
  padding: 5px 0 5px 0;
  margin: 0;
  border-top: 1px solid #eee !important;
}
.list-group-item.address {
  border: none !important;
  padding-top: 2px;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin: -36%;
}
#img-frame img {
  object-fit: contain;
  width: 20%;
  height: 20%;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}

</style>
